
/*
 *   File : bank.js
 *   Author URI : https://evoqins.com
 *   Description : Screen to add bank details.
 *   Integrations : null
 *   Version : v1.1
 */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import { GradientButton } from "../../../Component/CTA";
import { CustomTextInput, CustomFilePicker, FilePreview } from "../../../Component/Form-elements";

import APIService from "../../../Service/api-service";
import { _uploadDocumentToS3 } from "../../../Service/aws-service";
import { _isFileTypeAllowed } from "../../../Helper";
import Store from "../../../Store";

const MinorBankDetail = (props) => {
    const BANK_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA.bank_details);
    const [acNumber, setAcNumber] = useState(BANK_DATA.account_number !== null ? BANK_DATA.account_number : "");
    const [confirmAcNumber, setConfirmAcNumber] = useState(BANK_DATA.account_number !== null ? BANK_DATA.account_number : "");
    const [ifsc, setIfsc] = useState(BANK_DATA.ifsc_code !== null ? BANK_DATA.ifsc_code : "");
    const [acNumberError, setAcNumberError] = useState('');
    const [confirmAcNumberError, setConfirmAcNumberError] = useState('');
    const [ifscError, setIfscError] = useState('');

    const [cancelledCheque, setCancelledCheque] = useState(BANK_DATA.bank_cheque_url);
    const [cancelledChequeUrl, setCancelledChequeUrl] = useState(null);
    const [cancelledChequeError, setCancelledChequeError] = useState(null);
    const [apiLoader, setApiLoader] = useState(false);

    const [fileLoader, setFileLoader] = useState(false);

    useEffect(() => {
        if (BANK_DATA.bank_cheque_url) {
            const decodedURL1 = decodeURIComponent(decodeURIComponent(BANK_DATA.bank_cheque_url));
            const fileName1 = decodedURL1.split('?')[0].split("/").pop();
            setCancelledCheque(fileName1);
        }

    }, [BANK_DATA])

    // Form validation
    function _validateBankDetail() {
        let valid_form = true;
        let ifsc_regex = /^[A-Za-z]{4}\d{7}$/;

        if (acNumber.length === 0) {
            valid_form = false;
            setAcNumberError('Please provide account number');
        } else if (acNumber.length < 6 || acNumber.length > 18) {
            valid_form = false;
            setAcNumberError('Invalid Account number ');
        }
        // if (ifsc.length === 0 ){
        //     valid_form = false;
        if (ifsc.length === 0) {
            setIfscError('Please provide IFSC code');
        }
        else if (ifsc_regex.test(ifsc) === false) {
            valid_form = false;
            setIfscError('Invalid IFSC code');
        }
        if (valid_form === true) {
            setAcNumber('');
            setIfsc('');
            props.updateProgress(4);
        }
    };

    // Form validation
    function _submitBankDetail() {
        let valid_form = true;
        let ifsc_regex = /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/;

        if (acNumber.length === 0) {
            valid_form = false;
            setAcNumberError('Please provide account number');
        } else if (acNumber.length < 6 || acNumber.length > 18) {
            valid_form = false;
            setAcNumberError('Invalid Account number ');
        }

        if (confirmAcNumber.length === 0) {
            valid_form = false;
            setConfirmAcNumberError('Please provide account number');
        } else if (confirmAcNumber.length < 6 || confirmAcNumber.length > 18) {
            valid_form = false;
            setConfirmAcNumberError('Invalid Account number ');
        } else if (acNumber !== confirmAcNumber) {
            valid_form = false;
            setConfirmAcNumberError('Account number not matching with previous');
        }
        // if (ifsc.length === 0 ){
        //     valid_form = false;
        if (ifsc.length === 0) {
            setIfscError('Please provide IFSC code');
        }
        else if (ifsc_regex.test(ifsc?.toLocaleUpperCase()) === false) {
            valid_form = false;
            setIfscError('Invalid IFSC code');
        }


        if (cancelledCheque === null) {
            valid_form = false;
            setCancelledChequeError('Please upload cancelled cheque');
        }

        if (valid_form === true) {
            _addBank();

        }
    };


    function _handleCheque(path, file) {
        // eslint-disable-next-line
        var file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    _fileUpload(file_formatted, file, 2);
                } else {
                    setCancelledChequeError("File size should be less than 5mb");
                }
            }
            else {
                setCancelledChequeError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    }


    //API :: file upload api
    const _fileUpload = (key, file, type) => {
        setCancelledChequeError("");
        setFileLoader(type);
        let url = "general/file-upload";
        let body = {
            "key": `support/${key}`
        }

        APIService(true, url, body).then((response) => {
            if (response.status_code === 200) {
                setFileLoader(type);

                // s3 helper
                _uploadDocumentToS3(response.data, key, file).then((result) => {

                    setFileLoader(false);

                    setCancelledCheque(key);
                    setCancelledChequeUrl(response.data.view_info);


                }).catch(error => {
                    toast.dismiss();
                    toast.error(error, {
                        type: "error",
                    });
                    setFileLoader(false);
                });

            } else {
                setFileLoader(false);
                toast.dismiss();
                toast.error(response, {
                    type: "error",
                });
            }
        })
    }

    function _addBank() {
        setApiLoader(true);
        let url = 'kyc/add-bank-v2';
        let payload = JSON.stringify({
            "is_review": props.edit,
            "account_holder_name": "",
            "account_number": confirmAcNumber,
            "account_type_id": 147,
            "ifsc_code": ifsc,
            "is_default": true,
            "is_manual": true,
            "primary": true,
            "bank_cheque_url": cancelledCheque == null ? null : cancelledChequeUrl,
        });
        APIService(true, url, payload).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                Store.dispatch({
                    type: 'KYC_PROGRESS',
                    payload: response.kyc_data
                });
                if (response.bank_verification_needed === true) {
                    toast.error(response.data, {
                        type: 'error'
                    });
                } else {
                    toast.success(response.data || "Bank details added successfully");
                    props.updateProgress(5, props.text, props.is_manual);
                }
            } else {
toast.dismiss();
                toast.error(response.message, {
                    type: 'error'
                })
            }
            setApiLoader(false);
        })
    }
    return (

        <>
            <div className="row">
                <div className="col-md-8">
                    <h4 className="color-jett-black e-inter-bold e-font-24 mb-2">Minor bank account details</h4>
                    <p className="color-outer-space e-poppins-regular e-font-16 mb-3">Verify and register your account with mt wealth. As per regulatory requirements, you can invest through a registered bank account only.</p>

                    <div className="col-lg-6 col-12 mt-4">
                        <CustomTextInput value={acNumber}
                            label={`Enter savings account number`}
                            postfix="*"
                            type="number"
                            error={acNumberError}
                            handleChange={(e) => { if (e.length <= 16) setAcNumber(e); setAcNumberError('') }} />
                    </div>

                    <div className="col-lg-6 col-12 mt-4 pt-3">
                        <CustomTextInput value={confirmAcNumber}
                            label={`Re-enter savings account number`}
                            postfix="*"
                            error={confirmAcNumberError}
                            type="number"
                            handleChange={(e) => { if (e.length <= 16) setConfirmAcNumber(e); setConfirmAcNumberError('') }} />
                    </div>


                    <div className="col-lg-6 col-12 mt-4 pt-3">
                        <CustomTextInput value={ifsc}
                            label="IFSC Code"
                            postfix="*"
                            pan={true}
                            error={ifscError}
                            maxLength={11}
                            handleChange={(e) => { setIfsc(e); setIfscError('') }} />
                    </div>

                    <h5 className="color-jett-black e-poppins-medium e-font-18 mb-2 mt-4">Bank proofs</h5>
                    <p className="color-outer-space e-poppins-regular e-font-16 mb-2">
                        Please provide the following document as bank proof for your account:
                    </p>
                    <div className="row pt-3">
                        <div className="col-md-6">
                            <p className="color-black e-font-14 e-poppins-medium mb-2">Upload cancelled cheque<span className='color-red'>*</span> </p>
                            {
                                cancelledCheque === null ?
                                    (
                                        <CustomFilePicker accept=".png, .pdf, .jpeg "
                                            className="e-select-file"
                                            error={cancelledChequeError}
                                            loading={fileLoader === 2 ? true : false}
                                            onSelectFile={_handleCheque} />
                                    ) : (
                                        <FilePreview fileName={cancelledCheque}
                                            removeFile={() => setCancelledCheque(null)} />
                                    )
                            }
                        </div>
                    </div>
                    <div className="margin-32px-top">
                        {/* validation */}
                        <GradientButton label="Submit"
                            className="padding-12px-tb px-3 e-font-16"
                            loading={apiLoader}
                            handleClick={_submitBankDetail} />
                    </div>
                </div>
            </div>
        </>

    )

}

export default MinorBankDetail;